import React from 'react'
import {QuickTip} from 'components/generic'

interface Props {
  /**
   * Label string
   */
  label: string | object
  /**
   * Extra info will be shown next to label
   */
  info: string | React.ReactElement
  /**
   * Additional classes
   */
  className: string
  children?: React.ReactNode
  htmlFor: string
}

export const Label = ({htmlFor, label, info, className, children}: Props) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`text-sm flex justify-start items-center mb-1 className="block text-sm/6 font-medium text-gray-900
    ${className}
    `}>
      <>
        {label || children}
        {info && <QuickTip className="ml-2" tip={info} />}
      </>
    </label>
  )
}
